import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-secondary-50 mt-20">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-fill text-background-50 text-lg" />
              </span>
              <span className="font-heading font-black text-xl tracking-tight">黑料今日</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-200 max-w-md">
              每日更新的娱乐吃瓜日报。编辑部把当日热门爆料与精选汇总整理成固定栏目，
              让你订阅栏目后不错过任何一条新瓜，吃瓜追料一站看全。
            </p>
            <div className="mt-5 flex items-center gap-2 text-sm text-secondary-200">
              <span className="w-8 h-8 flex items-center justify-center bg-secondary-800 rounded-md">
                <i className="ri-mail-line" />
              </span>
              heyliao@example.com
            </div>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <h4 className="text-sm font-semibold text-secondary-100 tracking-wide">栏目导航</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/daily?cat=${cat.id}`}
                    className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-secondary-100 tracking-wide">关于本站</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer"
                >
                  常见问题
                </Link>
              </li>
              <li>
                <Link
                  to="/daily"
                  className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer"
                >
                  往期日报
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-secondary-400">
          <p>© 2026 黑料今日 · 本站内容为娱乐资讯整理，仅供信息参考。</p>
          <p>每日更新 · 理性吃瓜</p>
        </div>
      </div>
    </footer>
  );
}